import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Offcanvas, Form, Button } from "react-bootstrap";
// import EyeIcon from "../../../../assets/svg/EyeIcon";
import { pageVisit, sendOtpToMobile } from "../../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import parsePhoneNumber from "libphonenumber-js";
import { Toaster } from "../../../../utils/toaster";
import { APP_CONST } from "../../../../config/const";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

import VerifyIcon from "../../../../assets/images/icons/verify.png";
import SignUpIcon from "../../../../assets/images/icons/signup.png";

const MobileNumber = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [mobileNumber, setMobileNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [referalCode, setReferalCode] = useState(searchParams.get("refferal"));
  const [agentCode, setAgentCode] = useState(searchParams.get("agent_code"));
  const source = Boolean(document?.referrer)
    ? { source: document?.referrer }
    : {
        source: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
      };

  useEffect(() => {
    if (agentCode) {
      axios.get("https://api.ipify.org/?format=json").then((res) => {
        const payload = {
          referralCode: agentCode,
          platform: source.source,
          ip: res?.data?.ip,
        };
        const response = pageVisit(payload);
      });
    }
  }, []);
  const OTP = useSelector((state) => state?.app?.appDetails);
  const handleSubmit = () => {
    setIsSubmitting(true);
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    let payload = {};
    if (phoneNumber) {
      payload.mobile = phoneNumber.nationalNumber;
      payload.country_code = phoneNumber.countryCallingCode;
    }
    dispatch(sendOtpToMobile(payload))
      .then((res) => {
        setIsSubmitting(false);
        if (res?.data?.error === false) {
          persistDetails(payload);
          if (OTP === 0) {
            navigate("/register", {
              state: { referalCode, agentCode },
            });
          } else {
            navigate("/verify-number", {
              state: { referalCode, agentCode },
            });
          }
        } else {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, res?.data?.message);
        }
      })
      .catch((err) => {
        Toaster(APP_CONST.TOAST_TYPE.ERROR, err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  const persistDetails = (data) => {
    localStorage.setItem("mobile_details", JSON.stringify(data));
  };

  return (
    <Offcanvas
      className={"steps-canvas login-modal signup"}
      show={true}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <div className="offcanvas-main-box">
        <Offcanvas.Header>
          <Offcanvas.Title>Sign Up</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-steps">
            {/* <h2 className="h2">Welcome!</h2> */}
            {/* <p>Please enter your 10 digit mobile number to get an OTP</p> */}
            <div className="signup-steps">
              <div className="step step1">
                <div className="inner-box">
                  {/* <div className="ellipse"></div> */}
                  <div className="verifyIcon">
                    <img src={VerifyIcon} />
                  </div>
                  <div className="text">Phone Verification</div>
                </div>
              </div>
              <div className="step step2">
                <div className="seprator"></div>
                <div className="inner-box">
                  {/* <div className="ellipse"></div> */}
                  <div className="verifyIcon">
                    <img src={SignUpIcon} />
                  </div>
                  <div className="text">Signup</div>
                </div>
              </div>
            </div>

            <Form className="">
              <Form.Group
                className="mb-4 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Label>Phone number</Form.Label>
                <PhoneInput
                  country={"in"}
                  inputProps={{
                    name: "phone",
                    required: true,
                  }}
                  onlyCountries={["in"]}
                  inputStyle={{
                    display: "block",
                    width: "100%",
                    lineHeight: 1.5,
                    color: "#ffffff",
                    backgroundColor: "#26324B",
                    backgroundClip: "padding-box",
                    border: "#26324B",
                    borderRadius: "10px",
                    padding: "0.7rem 0.75rem",
                    borderColor: "#26324B",
                    fontSize: "0.86rem",
                    minHeight: "41px",
                    paddingLeft: "50px",
                  }}
                  onChange={(phone) => {
                    // alert("phone", phone);
                    // alert(phone);
                    setMobileNumber(phone);
                  }}
                />
              </Form.Group>

              <Button
                variant="primary"
                className="btn_primary mb-5"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending.." : "SEND OTP"}
              </Button>
            </Form>
            <div className="goToLogin">
              <span>Have an account? </span>
              <a href="/sign-in">Sign In</a>
            </div>
          </div>
        </Offcanvas.Body>
      </div>

      <div className="backToHome">
        <a
          href="javascript:void(0)"
          onClick={() => {
            navigate("/");
          }}
        >
          Back to Home
        </a>
      </div>
    </Offcanvas>
  );
};

export default MobileNumber;
